"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookupClient = void 0;
const base_client_1 = require("./base-client");
const token_1 = require("@app/domain/token");
const base_lookup_1 = require("@app/domain/entities/lookup/base-lookup");
class LookupClient extends base_client_1.BaseClient {
    constructor(tokenResolver = new token_1.Resolver()) {
        super('/esup/api/lookup_value/', tokenResolver);
    }
    async getTitleList() {
        try {
            const lookupValue = [];
            const response = await this.axios.get(`titles`);
            const responseLookups = response.data['hydra:member'];
            responseLookups.forEach((lookup) => {
                lookupValue.push(new base_lookup_1.BaseLookup(lookup.id, lookup.title));
            });
            return lookupValue;
        }
        catch (error) {
            console.log(`Error fetching titles`, error);
            throw error;
        }
    }
    async getSuffixesList() {
        try {
            const lookupValue = [];
            const response = await this.axios.get(`name_suffixes`);
            const responseLookups = response.data['hydra:member'];
            responseLookups.forEach((lookup) => {
                lookupValue.push(new base_lookup_1.BaseLookup(lookup.id, lookup.nameSuffix));
            });
            return lookupValue;
        }
        catch (error) {
            console.log(`Error fetching name suffixes`, error);
            throw error;
        }
    }
    async getGenderList() {
        try {
            const lookupValue = [];
            const response = await this.axios.get(`genders`);
            const responseLookups = response.data['hydra:member'];
            responseLookups.forEach((lookup) => {
                lookupValue.push(new base_lookup_1.BaseLookup(lookup.id, lookup.gender));
            });
            return lookupValue;
        }
        catch (error) {
            console.log(`Error fetching genders`, error);
            throw error;
        }
    }
    async getRaceList() {
        try {
            const lookupValue = [];
            const response = await this.axios.get(`races`);
            const responseLookups = response.data['hydra:member'];
            responseLookups.forEach((lookup) => {
                lookupValue.push(new base_lookup_1.BaseLookup(lookup.id, lookup.race));
            });
            return lookupValue;
        }
        catch (error) {
            console.log(`Error fetching races`, error);
            throw error;
        }
    }
    async getEthnicityList() {
        try {
            const lookupValue = [];
            const response = await this.axios.get(`ethnicities`);
            const responseLookups = response.data['hydra:member'];
            responseLookups.forEach((lookup) => {
                lookupValue.push(new base_lookup_1.BaseLookup(lookup.id, lookup.ethnicity));
            });
            return lookupValue;
        }
        catch (error) {
            console.log(`Error fetching ethnicities`, error);
            throw error;
        }
    }
    async getEyeColorList() {
        try {
            const lookupValue = [];
            const response = await this.axios.get(`eye_colors`);
            const responseLookups = response.data['hydra:member'];
            responseLookups.forEach((lookup) => {
                lookupValue.push(new base_lookup_1.BaseLookup(lookup.id, lookup.eyeColor));
            });
            return lookupValue;
        }
        catch (error) {
            console.log(`Error fetching eye colors`, error);
            throw error;
        }
    }
    async getHairColorList() {
        try {
            const lookupValue = [];
            const response = await this.axios.get(`hair_colors`);
            const responseLookups = response.data['hydra:member'];
            responseLookups.forEach((lookup) => {
                lookupValue.push(new base_lookup_1.BaseLookup(lookup.id, lookup.hairColor));
            });
            return lookupValue;
        }
        catch (error) {
            console.log(`Error fetching hair colors`, error);
            throw error;
        }
    }
    async getStateList() {
        try {
            const lookupValue = [];
            const response = await this.axios.get(`states?page=1`);
            const responseLookups = response.data['hydra:member'];
            const totalItems = response.data['hydra:totalItems'];
            const totalPages = Math.ceil(totalItems / 30);
            responseLookups.forEach((lookup) => {
                lookupValue.push(new base_lookup_1.BaseLookup(lookup.id, lookup.state));
            });
            if (totalPages > 1) {
                const pageRequests = [];
                for (let page = 2; page <= totalPages; page++) {
                    pageRequests.push(this.axios.get(`states?page=${page}`));
                }
                const pageResponses = await Promise.all(pageRequests);
                for (const res of pageResponses) {
                    const lookups = res.data['hydra:member'];
                    lookups.forEach((lookup) => {
                        lookupValue.push(new base_lookup_1.BaseLookup(lookup.id, lookup.state));
                    });
                }
            }
            return lookupValue;
        }
        catch (error) {
            console.log(`Error fetching hair colors`, error);
            throw error;
        }
    }
}
exports.LookupClient = LookupClient;
